module.exports = __webpack_public_path__ + "img/RedWhiteGrayFooter.bbe2d418.jpg";